export async function delay(timeMs: number) {
  return new Promise((res) => {
    setTimeout(res, timeMs);
  });
}
